import axios from "axios";
import { Message, MessageBox } from "element-ui";
import store from "@/store/index";
import { getToken, getRefreshToken } from "@/utils/auth";

import { rrjApiBase } from "@/config/config";
import { $rrj } from "@/utils/rrjutils";

// 创建axios实例
const service = axios.create({
  baseURL: rrjApiBase, // api的base_url
  timeout: 200000, // 请求超时时间20s
});

let errorCount = 0;

// request拦截器
service.interceptors.request.use(
  (config) => {
    // console.log(config.params, "config.params");
    // 默认带上参数u
    if (!config.params) {
      config.params = {
        u: $rrj.storage.get("_ukit") && $rrj.storage.get("_ukit").id,
      };
    } else if (!config.params.u) {
      for (let i in config.params) {
        if (config.params[i] !== 0 && !config.params[i]) {
          delete config.params[i];
        }
      }
      config.params.u =
        $rrj.storage.get("_ukit") && $rrj.storage.get("_ukit").id;
    }

    if (!config.headers) {
      config.headers = {};
    }

    if (getToken()) {
      if (!config.headers["Authorization"]) {
        config.headers["Authorization"] = $rrj.storage.get("_token").id; // 让每个请求携带自定义token 请根据实际情况自行修改
      }
      return config;
    } else if (getRefreshToken()) {
      return new Promise((resolve) => {
        store.dispatch("RefreshToken").then(() => {
          if (!config.headers["Authorization"]) {
            config.headers["Authorization"] = $rrj.storage.get("_token").id;
          }
          resolve(config);
        });
      });
    } else {
      return new Promise(() => {
        store.dispatch("LogOut").then(() => {
          location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
      });
    }
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    /**
     * result= 'fail'跑出错误
     */
    const res = response.data;
    if (res.result === "fail") {
      console.log(res.message, "fail res.message");
      // Message({
      //   message: res.message,
      //   type: "error",
      //   duration: 5 * 1000,
      // });

      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm(
          "你已被登出，可以取消继续留在该页面，或者重新登录",
          "确定登出",
          {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        });
      }
      return response.data;
    } else {
      return response.data;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    if (error && error.message !== "Network Error") {
      // 确保 message 是字符串而不是对象
      const message =
        typeof error.message === "object"
          ? JSON.stringify(error.message)
          : error.message;
      // 报错大于5次 直接退出重新登录 // 临时解决用户进入页面批量报"[object Object]" is not valid JSON
      if (errorCount > 5) {
        errorCount = 0;
        localStorage.clear();
        sessionStorage.clear();
        window.open("/#/login");
        return;
      }

      errorCount++;

      Message({
        message: message,
        type: "error",
        duration: 5 * 1000,
      });
    }
    return Promise.reject(error);
  }
);

export default service;
